import React, { useState } from 'react'
import { Button, Col, Container, Dropdown, Row } from 'react-bootstrap'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Navbar } from 'react-bootstrap'
import { Nav } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import CommonButton from '@/components/Common/commonButton'
import styles from '../../../styles/Home.module.css'
import Link from 'next/link'
import {ToastContainer } from 'react-toastify'
import Image from 'next/image'
import CallToActionForm from './CallToActionForm'

const HeaderWithModules = (props) => {

    if(props?.hideHeader == '1') return <></>

  const [url, setUrl] = useState({ url: '', error: false })
  const [productDropdown, setProductDropdown] = useState(false)
  const [navExpanded, setNavExpanded] = useState(false)
  const [loginModal, setLoginModal] = useState(false)
  const [ShowCallToActionForm, SetShowCallToActionForm] = useState(false)

  const closeNav = () => {
    setNavExpanded(false)
    setProductDropdown(false)
    setLoginModal(false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (url !== '') {
      window.open(`https://${url.url}.webhr.co/`, '_blank')
      setUrl('')
    }
  }

  const openTabInMob = ()=>{
    setProductDropdown(!productDropdown)
  }

  return (
    <div className={styles.NewHeaderheader}>
      <Container>
        <Navbar expanded={navExpanded} sticky="top" expand="lg">
          <Link href="/"  onClick={closeNav}>
              <Image src="/WebHR.svg" alt='webhr' width={135} height={60} />
          </Link>
          <Navbar.Toggle aria-controls="navbarScroll" onClick={() => setNavExpanded(!navExpanded)} />
          <Navbar.Collapse id="navbarScroll" onMouseLeave={() => setProductDropdown(false) }>
            <Nav className="me-auto my-2 my-lg-0" style={{ flex: 1, marginLeft: 20 }} navbarScroll>
              <Dropdown show={productDropdown} className={styles.newDropdownStyles}>
                <Dropdown.Toggle className={styles.dropdownStyleNew} onClick={openTabInMob} onMouseEnter={openTabInMob}>
                  Product
                </Dropdown.Toggle>

                <Dropdown.Menu  className={styles.headerDropdown} style={{marginTop:22, width:"70em", minWidth:"100%", overflowY:"auto", background:"#cdcdcd"}} onMouseEnter={() => setProductDropdown(true)} onMouseLeave={() => setProductDropdown(false)}>
                  <Row style={{backgroundColor:"#fff"}} >

                  <Col  style={{ paddingBlock: 20, }} onMouseEnter={() => setProductDropdown(true)} onMouseLeave={() => setProductDropdown(true)}>
                    {/* <div className={styles.headerBorder}></div> */}
                    <h4 style={{ color: '#ADB5BD' }}>WebHR Modules</h4>
                    <Row >
                      <Col xl="4" lg="5" md="5" sm="12">
                        <Link href="/modules/core-hr" style={{ textDecoration: 'none' }} onClick={closeNav}>
                          <div className={styles.navbarModules}>
                            <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/core_hr.svg" height={20} style={{ marginRight: 15 }} />
                            <div>
                              <h5>Core HR</h5>
                              <p>
                                Multi-user role based system, document management, Comprehensive report and <br /> graphs.
                              </p>
                            </div>
                          </div>{' '}
                        </Link>
                      </Col>
                      <Col xl="4" lg="5" md="5"  sm="12">
                        <Link href="/modules/performance" style={{ textDecoration: 'none' }} onClick={closeNav}>
                          <div className={styles.navbarModules}>
                            <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/performance.svg" height={20} style={{ marginRight: 15 }} />
                            <div>
                              <h5>Performance</h5>
                              <p>Boost employee performance with our intuitive Performance Module. Drive success through goals and real-time feedback.</p>
                            </div>
                          </div>
                        </Link>
                      </Col>
                      <Col xl="4" lg="5" md="5"  sm="12">
                        <Link href="/modules/payroll" style={{ textDecoration: 'none' }} onClick={closeNav}>
                          <div className={styles.navbarModules}>
                            <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/payroll.svg" height={22} style={{ marginRight: 15 }} />
                            <div>
                              <h5>Payroll</h5>
                              <p>Automate your payroll process and seamlessly oversee employee payroll with our extensive Payroll Module.</p>
                            </div>
                          </div>
                        </Link>
                      </Col>
                      <Col xl="4" lg="5" md="5"  sm="12">
                        <Link href="/modules/time-and-attendance" style={{ textDecoration: 'none' }} onClick={closeNav}>
                          <div className={styles.navbarModules}>
                            <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/time_attendance.svg" height={22} style={{ marginRight: 15 }} />
                            <div>
                              <h5>Time & Attendance</h5>
                              <p>Employees can track time anywhere using an Android or iOS mobile phone, computer, and tablet by clock in and out.</p>
                            </div>
                          </div>
                        </Link>
                      </Col>
                      <Col xl="4" lg="5" md="5"  sm="12">
                        <Link href="/modules/recruitment" style={{ textDecoration: 'none' }} onClick={closeNav}>
                          <div className={styles.navbarModules}>
                            <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/recruitment.svg" height={22} style={{ marginRight: 15 }} />
                            <div>
                              <h5>Recruitment</h5>
                              <p>From creating job posts to onboarding top talent, our recruitment module makes hiring a breeze.</p>
                            </div>
                          </div>
                        </Link>
                      </Col>
                      <Col xl="4" lg="5" md="5"  sm="12">
                        <Link href="/modules" style={{ textDecoration: 'none' }} onClick={closeNav}>
                          <div className={styles.navbarModules}>
                            <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/base_modules.svg" height={22} style={{ marginRight: 15 }} />

                            <div>
                              <h5>WebHR Modules</h5>
                              <p>WebHR is an All-In-One Social HR Software, we offer more than 45+ modules. Click here to develop deeper understanding.</p>
                            </div>
                          </div>
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                  </Row>
                </Dropdown.Menu>
              </Dropdown>
                <Nav.Link className={`${styles.navLinks}`} style={{marginTop:"6px", height:"100%", paddingLeft:"0px", marginLeft:"0px"}} href="/pricing">
                  Pricing & Signup
                </Nav.Link>
                <Nav.Link className={`${styles.navLinks}`} style={{marginTop:"6px", height:"100%", paddingLeft:"0px", marginLeft:"0px" }}  href="/demo">
                  Free Demo
                </Nav.Link>
            </Nav>
            <Nav>
              <Dropdown show={loginModal}>
                <Dropdown.Toggle 
                onMouseEnter={() => {
                  setProductDropdown(false)
                  setLoginModal(!loginModal)
                }}
                onClick={()=>{
                  setProductDropdown(false)
                  setLoginModal(!loginModal)
                }} 
                onMouseLeave={() => setLoginModal(false)} 
                className={styles.outlineLoginBtn} 
                style={{ backgroundColor: 'white' }}>
                  Login
                </Dropdown.Toggle>
                  <Dropdown.Menu className={styles.dropdownMenu3} onMouseEnter={() => setLoginModal(true)} onMouseLeave={() => setLoginModal(false)} >
                    <ToastContainer position="bottom-left" toastStyle={{ backgroundColor: 'red' }} autoClose={2500} hideProgressBar newestOnTop={false} closeOnClick={false} rtl={false} pauseOnFocusLoss draggable={false} pauseOnHover={false} />
                    <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/sheild.svg" />
                    <h3 style={{ marginTop: 20, marginBottom: 0 }}>Welcome Back,</h3>
                    <p style={{ color: '#ADB5BD', padding: 0, fontSize: 13 }}>Please enter your designated Instance URL.</p>
                    <Form name='urlForm' onSubmit={handleSubmit}>
                      <div style={{ flexDirection: 'row', display: 'flex', color: '#ADB5BD', marginBottom: 10 }}>
                        <Form.Label column lg={2}>
                          https://
                        </Form.Label>
                        <Col lg={7} style={{ marginInline: 10 }}>
                          <Form.Control style={{ borderRadius: 50, paddingInline: 15, borderColor: url.error ? 'red' : '' }} name={"url"} autoFocus value={url.url} onChange={(e) => setUrl({ ...url, url: e.target.value })} type="text" placeholder="Enter your domain" />
                        </Col>
                        <Form.Label column lg={2}>
                          .webhr.co/
                        </Form.Label>
                      </div>
                      <Button className={styles.primaryBtn} onClick={handleSubmit} type="submit">
                        Login
                      </Button>
                      <div className={styles.loginGoogleRow}>
                        <Link href={'/google-login'} target="_blank" className={styles.googleLoginModal} >
                          <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/google.svg" width={30} height={30} />
                        </Link>
                        <Link href={'/login'} target="_blank" className={styles.googleLoginModal}>
                          <LazyLoadImage src="https://cdn.webhr.co/Website/images/components/azure.svg"  width={30} height={30}  />
                        </Link>
                      </div>
                    </Form>
                  </Dropdown.Menu>
              </Dropdown>
            </Nav>
              <Button className={styles.outlineHeaderBtn} onClick={()=>SetShowCallToActionForm(true)} type="submit">
                Signup for free
              </Button>
          </Navbar.Collapse>
        </Navbar>
      </Container>
      <CallToActionForm show={ShowCallToActionForm} onHide={() => SetShowCallToActionForm(false)} />

     </div>
  )
}
export default HeaderWithModules
